import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HowHenterPantWorksComponent } from './how-henter-pant-works.component';

const routes: Routes = [
  {
    path: '',
    component: HowHenterPantWorksComponent,
    data: { titleKey: 'HOW_HENTERPANT_WORKS.TITLE', ogKey: 'HENTERPANT' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HowHenterPantWorksRoutingModule {}

